module.exports = __webpack_public_path__ + "img/calendar.9508a9b1.svg";